import Link from "next/link";

import Button from "../../components/button";
import Hero from "../../components/hero";
import MeetOurClients from "../../components/meet-our-clients";
import OptionListItem from "../../components/option-list-item";
import SocialMembership from "../../components/social-membership";

import styles from "./solutions.module.scss";
import SeoMeta from "../../components/seo-meta";
import config from "../../config";

export default function Solutions({ solutions, seo }) {
  return (
    <>
      <div className="container">
        <SeoMeta {...seo} />
        <Hero
          title="Solutions"
          description="Explore our solutions, including Open Space memberships with access to business mailing and events, Private Space memberships with flexible lease terms for turnkey offices, and Spaces for Hire for corporate and private event bookings."
        />

        <div className={styles.SpacesWrapper}>
          {solutions.map((solution) => (
            <div key={solution.name} className={styles.SpaceList}>
              <div className={styles.SpaceDescription}>
                <div className={styles.SpaceText}>
                  <Link href={`/solutions/${solution.slug}`} passHref>
                    <a>
                      <h2 className="underline">{solution.name}</h2>
                    </a>
                  </Link>
                  <p>{solution.subtitle}</p>
                </div>

                <div className={styles.ExploreButtonDesktop}>
                  <Link href={`/solutions/${solution.slug}`} passHref>
                    <a>
                      <Button outline rounded small>
                        Explore {solution.name}
                      </Button>
                    </a>
                  </Link>
                </div>
              </div>
              <div className={styles.SpaceOptionsList}>
                {solution.optionsCollection.items.map((option) => (
                  <OptionListItem key={option.name} option={option} />
                ))}
              </div>

              <div className={styles.ExploreButtonMobile}>
                <Link href={`/solutions/${solution.slug}`} passHref>
                  <Button outline rounded small>
                    Explore {solution.name}
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      <SocialMembership
        title="Refer a Friend and Make Bank"
        subtitle="Referral"
        description="Refer like-minded companies, independent professionals, and social-event seekers to East Room. When they sign up or use our services, you’ll earn credits toward your membership."
        url="/referral-program"
        image="/images/member.gif"
        buttonText="Refer Here"
      />

      <MeetOurClients />
    </>
  );
}

export async function getStaticProps() {
  try {
    const { getSolutions } = await import("../../lib/solutions");
    const { getSEOPageProps } = await import("../../lib/seo");
    
    const [solutions, seo] = await Promise.all([
      getSolutions(),
      getSEOPageProps({ resolvedUrl: "/solutions" })
    ]);

    return {
      props: { solutions, seo },
      revalidate: config.ISR_TIMING
    };
  } catch (e) {
    console.log(e.message);
    // Fail the build rather than ship an empty page. During ISR revalidation
    // Next catches this and keeps serving the last good render.
    throw e;
  }
}
